import get from "../../../../api/methods/get";
import {JOURNEY_QUERY} from "../journeyEndpoints";

export const queryJourneys = async (groupId) => {

    let result = await get(JOURNEY_QUERY(groupId));
    let json = await result.json();
    return json.data;

}
